import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { Filter } from '@brafton/angular-framework-library';
import { SowService } from '@brafton/atlas-api-client';
import { IPagedList, StatementOfWork } from '@brafton/common-framework-library';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'shared-filter-panel-sows',
  templateUrl: './filter-panel-sows.component.html',
  styleUrls: ['./filter-panel-sows.component.scss'],
  host: { class: 'filter-panel-sows' },
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SharedFilterPanelSowsComponent implements OnInit {
  @Input() sows: Filter[] = [];
  @Output() sowsChange: EventEmitter<Filter[]> = new EventEmitter<Filter[]>();
  @Output() close: EventEmitter<any> = new EventEmitter();
  @Input() feedId?: number;

  sows$!: Observable<StatementOfWork[]>;

  constructor(private sowService: SowService) {}

  ngOnInit() {
    this.sows$ = this.sowService
      .listSOWs(1, 100, this.feedId?.toString())
      .pipe(map((r: IPagedList<StatementOfWork>) => r.items));
  }

  add(sowDef: StatementOfWork) {
    if (!this.sows.find((sp) => sp.value === sowDef.id)) {
      this.sows.push({ value: sowDef.id, displayName: sowDef.name, type: 'sow' } as Filter);
    }
    this.sowsChange.emit(this.sows);
  }

  remove(sowDef: StatementOfWork) {
    const index = this.sows.findIndex((sp) => sp.value === sowDef.id);
    if (index > -1) {
      this.sows.splice(index, 1);
    }
    this.sowsChange.emit(this.sows);
  }

  clear() {
    this.sows = [];
    this.sowsChange.emit(this.sows);
  }

  isSelected(sowDef: StatementOfWork): boolean {
    if (!this.sows) return false;
    if (this.sows.find((sp) => sp.value === sowDef.id)) return true;
    else return false;
  }
}
